import React from 'react';
import {
  makeStyles,
  Card,
  Typography,
  Grid,
} from '@material-ui/core/';
import RoomOutlinedIcon from '@material-ui/icons/RoomOutlined';
import PhoneOutlinedIcon from '@material-ui/icons/PhoneOutlined';
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined';

const useStyles = makeStyles(() => ({
    root: {
      maxWidth: 400,
      maxHeight: 430,
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      zIndex:2,
      textAlign: 'center',
      padding: '2% 0%',
    },
    iconStyle: {
      alignSelf: 'center',
      margin: '0% 3%',
    },
    marBot: {
      marginBottom: '14%',
    },
    gridItem: {
      width: '55%',
    }
  }));

  function Contact() {
    const classes = useStyles();

    return(
        <Card className={classes.root}>

            
            <Grid className={classes.marBot} container justify='center' >
            <RoomOutlinedIcon className={classes.iconStyle} color='primary' fontSize='large' />
            <Grid item className={classes.gridItem}>
                <Typography variant="body1" color='textPrimary' >
                Dolní Věstonice 29
                </Typography>
                <Typography variant="subtitle1" color='textSecondary' >
                691 29, Dolní Věstonice
                </Typography>
            </Grid>
            </Grid>

            <Grid className={classes.marBot} container justify='center' >
            <PhoneOutlinedIcon className={classes.iconStyle} color='primary' fontSize='large' />
            <Grid item className={classes.gridItem}>
                <Typography variant="body1" color='textPrimary' >
                +420 603 576 670 
                </Typography>
                <Typography variant="body1" color='textSecondary' >
                +420 728 649 081
                </Typography>
            </Grid>
            </Grid>

            <Grid className={classes.marBot} container justify='center' >
            <EmailOutlinedIcon className={classes.iconStyle} color='primary' fontSize='large' />
            <Typography className={classes.gridItem} variant="body1" color='textPrimary' >
                v.macanova@seznam.cz
            </Typography>
            </Grid>
        </Card>
    )
  }

  export default Contact;
